import { render, staticRenderFns } from "./RDCOnboard.vue?vue&type=template&id=653ff7c4"
import script from "./RDCOnboard.vue?vue&type=script&lang=js"
export * from "./RDCOnboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports